import { bus } from "@/main";
import { getExhibitionsList } from "../../../data/models/exhibition.model";

export default {
	name: "ArchiivePage",
	data() {
		return {
			language: this.$route.params.lang,
			exhibitionsIsReady: false,
			contentIsReady: false,
			exhibitions: [],
			bgImage: false,
			currentArea: null,
			currentPage: 1,
			totalPages: null,
			totalExhibitions: null,
		}
	},
	props: {},
	created() {
		this.getContent();
		window.addEventListener("mousemove", function () {
			let bg = document.getElementsByClassName('archive__bg');
			if (bg && bg[0]) {
				bg[0].style.left = event.pageX - bg[0].offsetWidth / 2 + 'px';
				bg[0].style.top = event.pageY - bg[0].offsetHeight / 2 + 'px';
			}
		});
	},
	watch: {
		$route: function() {
			this.getContent();
		},
	},
	computed: {},
	methods: {
		getContent(){
			let exhibitionsList = new Promise ((resolve,reject) => {
				getExhibitionsList(2).then(
					content => {
						this.exhibitions = content.content;
						this.totalPages = content.totalPages;
						this.totalExhibitions = content.totalExhibitions;
						this.exhibitionsIsReady = true;
						resolve(true);
					}
				);
			});
			Promise.all([exhibitionsList]).then(() => {
				bus.$emit("evalColors", true);
				bus.$emit("PAGE_IS_READY", true);
			})
		},
		getMoreContent(page) {
			getExhibitionsList(1, page).then(content => {
				content.content.forEach(element => {
					this.exhibitions.push(element)
				});
				this.totalPages = content.totalPages;
				this.totalExhibitions = content.totalExhibitions;
				this.currentPage ++;
			});
		},
		showImage: function (event, value) {
			this.bgImage = value;
		},
		hideImage: function (value) {
			this.bgImage = null;
		},
		// skewOnScroll: function () {
		// 	const articles = document.getElementsByClassName("archive__content__item")
		// 	let currentPixel = window.pageYOffset

		// 	const looper = function () {
		// 		const newPixel = window.pageYOffset;
		// 		const diff = newPixel - currentPixel;
		// 		const speed = diff * 0.8

		// 		for ( let i = 0; i < articles.length; i++ ) {
		// 			articles[i].style.transform = "skewY(" + speed +"deg)"
		// 		}
		// 		currentPixel = newPixel;
		// 		requestAnimationFrame(looper);
		// 	}
		// 	looper();
		// },
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/archive/archive.page.js